export default {
      id: "settings-magic-button-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite-46b249.svg#settings-magic-button-usage",
      toString: function () {
        return this.url;
      }
    }